module.exports = __webpack_public_path__ + "b062f7ed6d19de50d6fe59b8b8b35183.jpg";